import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import ModeOutlinedIcon from "@mui/icons-material/ModeOutlined";
import {Checkbox, FormControlLabel} from "@mui/material";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Cookies from "js-cookie";
import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate, useSearchParams} from "react-router-dom";
import {ROLE, TAX_CODES} from "../../constants";

import {getEmptyCashRegister, removeCashRegisterTax, upsertCashRegisterTax,} from "../../services/requests/ApiRequests";
import {valueToFixed} from "../../services/toFixed";
import RU from "../../services/translation/ru.json";
import {translation} from "../../services/translation/translation";
import ReportDialog from "../admin_components/ReportDialog";
import CashPicker from "./CashPicker";

export default function Taxes(props) {
	const {t} = useTranslation();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const registerId = searchParams.get("rid");
	const companyId = searchParams.get("cid");

	const formRef = useRef();
	const [dict, setDict] = useState(RU);
	const [taxesList, setTaxesList] = useState([]);
	const [taxAvailableCodes, setTaxAvailableCodes] = useState(TAX_CODES);
	const [openTaxEditDialog, serOpenTaxEditDialog] = useState(false);
	const [openTaxAddDialog, serOpenTaxAddDialog] = useState(false);
	const [openTaxRemoveDialog, serOpenTaxRemoveDialog] = useState(false);
	const [card, setCard] = useState({});
	const [organization, setOrganization] = useState(null);
	const [registerStatus, setRegisterStatus] = useState({
		isChecking: false,
		error: "",
	});
	const [taxSelected, setTaxSelected] = useState({
		id: 0,
		code: "",
		title: "",
		rate: 0,
		percent: "",
		enabled: false,
	});

	useEffect(() => {
		if (!card.idnx) return;

		setRegisterStatus({
			isChecking: true,
			error: "",
		});
		getEmptyCashRegister({
			...card,
			type: 3,
		})
			.then((data) => {
				if (data.data.success) {
					setRegisterStatus({
						isChecking: false,
						error: "",
					});
				} else {
					setRegisterStatus({
						isChecking: false,
						error: data.data.error,
					});
				}
			})
			.catch((error) => {
				setRegisterStatus({
					isChecking: false,
					error: error.response.data.error,
				});
			});
	}, [card]);

	useEffect(() => {
		const lang = Cookies.get("simpalsid.lang");
		if (!lang) return;
		setDict(translation(lang));
	}, []);

	useEffect(() => {
		const taxes = organization?.cash_registers?.[0]?.taxes;
		if (taxes) {
			setTaxesList(taxes);
		}
	}, [organization]);

	useEffect(() => {
		if (!organization) return;

		const codesArray = taxesList?.map((tax) => tax.code);
		setTaxAvailableCodes((taxAvailableCodes) =>
			taxAvailableCodes.filter((el) => !codesArray.includes(el))
		);
	}, [taxesList, organization]);

	const onSubmitCashRegisterForm = (data) => {
		setCard(data.formData);
		setOrganization(data.organization);
	};

	function createCodesList(taxes) {
		const codesArray = taxes?.map((tax) => tax.code);
		setTaxAvailableCodes(
			taxAvailableCodes.filter((el) => !codesArray.includes(el))
		);
	}

	function editTax(tax) {
		const requestBody = {
			card: {
				...card,
			},
			tax,
		};
		upsertCashRegisterTax(requestBody).then((data) => {
			if (data.data.taxes) {
				const taxes = data.data.taxes;
				serOpenTaxAddDialog(false);
				setTaxesList(taxes);
				handleCloseDialog();
			}
		});
	}

	function handleTaxRemove() {
		const requestBody = {
			card: {
				...card,
			},
			tax_id: taxSelected._id,
		};

		removeCashRegisterTax(requestBody).then((data) => {
			if (data.data.taxes) {
				const taxes = data.data.taxes;
				serOpenTaxRemoveDialog(false);
				setTaxesList(taxes);
				setTaxAvailableCodes(
					[...taxAvailableCodes, taxSelected.code].sort()
				);
				handleCloseDialog();
			}
		});
	}

	function handleChangeTax(event) {
		setTaxSelected({
			...taxSelected,
			...{percent: valueToFixed(event.target.value, 99)},
		});
	}

	function handleChangeField(event, name) {
		let newfield = {};
		if (name === "percent") {
			newfield[name] = valueToFixed(event.target.value, 99);
		} else {
			newfield[name] = event.target.value;
		}
		setTaxSelected({...taxSelected, ...newfield});
	}

	function handleTaxAdd(e) {
		e.preventDefault();
		formRef.current.reportValidity();
		if (formRef.current.checkValidity()) {
			const requestBody = {
				card: {
					...card,
				},
				tax: {
					...taxSelected,
					percent: taxSelected.code === "_" ? 0 : taxSelected.percent,
				},
			};
			upsertCashRegisterTax(requestBody).then((data) => {
				if (data.data.taxes) {
					const taxes = data.data.taxes;
					serOpenTaxAddDialog(false);
					setTaxesList(taxes);
					createCodesList(taxes);
					handleCloseDialog();
				}
			});
		}
	}

	function handleCloseDialog() {
		if (openTaxAddDialog) serOpenTaxAddDialog(false);
		if (openTaxEditDialog) serOpenTaxEditDialog(false);
		if (openTaxRemoveDialog) serOpenTaxRemoveDialog(false);
		setTaxSelected({
			id: 0,
			code: "",
			title: "",
			rate: 0,
			percent: "0",
			enabled: false,
		});
	}

	function handleTaxChnage(e, tax) {
		const changedTax = {...tax, enabled: e.target.checked};
		setTaxSelected(changedTax);
		editTax(changedTax);
	}

	if (props.role === ROLE.cashier) return null;

	return (
		<Box
			sx={{flexGrow: 1, marginTop: 3, marginLeft: 0, marginBottom: 10}}
		>
			{companyId && registerId && (
				<Button
					variant="text"
					color="secondary"
					onClick={() => {
						navigate(`/cash-register/${companyId}/${registerId}`);
					}}
				>
					&#60; {dict.go_back}
				</Button>
			)}
			{registerStatus.error && (
				<ReportDialog
					message={registerStatus.error}
					setError={() => {
						setRegisterStatus({
							isChecking: false,
							error: "",
						});
					}}
					card={card}
					withBackButton
				/>
			)}
			<Grid container spacing={2} align="left">
				<Grid item xs={7}>
					<CashPicker onSubmit={onSubmitCashRegisterForm}/>
				</Grid>

				<Grid item xs={4} sx={{marginLeft: 1}}>
					<Typography
						sx={{fontSize: 24, marginTop: 6, marginBottom: 3}}
						color="pimary"
						gutterBottom
					>
						{t("TVA_taxes")}:
					</Typography>
					{taxesList?.map((item) => {


						return (
							<div key={item._id}>
								<Box sx={{borderTop: "1px solid #ddd"}}>
									<FormControlLabel
										control={
											<Checkbox
												disabled={
													registerStatus.isChecking ||
													registerStatus.error
												}
											/>
										}
										label={
											item.code === "_"
												? t("no_vat")
												: `${
													item.code
												} ${item.percent.toFixed(2)}%`
										}
										checked={item.enabled}
										name={item.title}
										sx={{
											width: "calc( 100% - 110px)",
											marginTop: 1,
											paddingBottom: 1,
										}}
										onChange={(e) =>
											handleTaxChnage(e, item)
										}
									/>
									{item.code !== "_" ? <IconButton
										aria-label="edit"
										size="large"
										disabled={
											registerStatus.isChecking ||
											registerStatus.error
										}
										onClick={(e) => {
											setTaxSelected(item);
											serOpenTaxEditDialog(true);
										}}
									>
										<ModeOutlinedIcon/>
									</IconButton> : <Box sx={{width: '48px', display: 'inline-flex'}}/>}
									<IconButton
										aria-label="delete"
										size="large"
										disabled={
											registerStatus.isChecking ||
											registerStatus.error
										}
										onClick={(e) => {
											setTaxSelected(item);
											serOpenTaxRemoveDialog(true);
										}}
									>
										<DeleteForeverOutlinedIcon/>
									</IconButton>
								</Box>
							</div>
						);
					})}
					{organization && (
						<Button
							disabled={
								registerStatus.isChecking ||
								registerStatus.error
							}
							variant="outlined"
							sx={{
								marginTop: 2,
								width: "100%",
							}}
							onClick={() => serOpenTaxAddDialog(true)}
						>
							{t("new_taxes_btn")}
						</Button>
					)}
				</Grid>
			</Grid>

			<Dialog
				open={openTaxRemoveDialog}
				onClose={handleCloseDialog}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{t("delete_tva_tax")}
				</DialogTitle>
				<DialogContent>
					<Button
						variant="contained"
						onClick={handleTaxRemove}
						sx={{marginTop: 2}}
					>
						{t("yes")}
					</Button>
					<Button
						variant="outlined"
						sx={{marginTop: 2, marginLeft: 2}}
						onClick={handleCloseDialog}
					>
						{t("cancel")}
					</Button>
				</DialogContent>
			</Dialog>

			<Dialog open={openTaxEditDialog} onClose={handleCloseDialog}>
				<DialogTitle>{t("edit_tva_tax")}</DialogTitle>
				<DialogContent>
					<TextField
						id="outlined-basic"
						label={t("percent")}
						onChange={(event) => handleChangeTax(event)}
						fullWidth
						sx={{marginTop: 1}}
						variant="standard"
						value={parseFloat(taxSelected.percent).toFixed(2)}
					/>
					<Button
						variant="outlined"
						sx={{marginTop: 2}}
						onClick={handleCloseDialog}
					>
						{t("cancel")}
					</Button>
					<Button
						variant="contained"
						onClick={() => editTax(taxSelected)}
						sx={{marginTop: 2, marginLeft: 2}}
					>
						{t("save")}
					</Button>
				</DialogContent>
			</Dialog>

			<Dialog
				open={openTaxAddDialog}
				onClose={handleCloseDialog}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{t("add_tva_tax")}
				</DialogTitle>
				<DialogContent>
					<Box
						component="form"
						sx={{
							"& .MuiTextField-root": {
								marginTop: 2,
								width: "25ch",
							},
						}}
						noValidate
						onSubmit={handleTaxAdd}
						ref={formRef}
					>
						<TextField
							select
							label={t("tva_code")}
							onChange={(event) =>
								handleChangeField(event, "code")
							}
							fullWidth
							sx={{marginTop: 2}}
							variant="standard"
							defaultValue={taxSelected.code}
							required
							error={
								taxesList.filter(
									(el) => el.code === taxSelected.code
								).length !== 0
							}
							helperText={
								taxesList.filter(
									(el) => el.code === taxSelected.code
								).length === 0
									? t("select_from_list")
									: t("this_value_exists")
							}
						>
							{taxAvailableCodes.map((option) => (
								<MenuItem key={option} value={option}>
									{option === "_" ? t("no_vat") : option}
								</MenuItem>
							))}
						</TextField>

						<TextField
							label={t("tva_percent")}
							onChange={(event) =>
								handleChangeField(event, "percent")
							}
							name="percent"
							variant="standard"
							sx={{marginTop: 2, marginLeft: 2}}
							fullWidth
							value={
								taxSelected.code === "_"
									? 0
									: taxSelected.percent
							}
							required
							disabled={taxSelected.code === "_"}
							error={
								taxesList.filter(
									(el) =>
										parseFloat(el.percent) ===
										parseFloat(taxSelected.percent)
								).length !== 0
							}
							helperText={
								taxesList.filter(
									(el) =>
										parseFloat(el.percent) ===
										parseFloat(taxSelected.percent)
								).length === 0
									? t("enter_percent")
									: t("this_value_exists")
							}
						/>
						<Button
							variant="outlined"
							sx={{marginTop: 2}}
							onClick={handleCloseDialog}
						>
							{t("cancel")}
						</Button>
						<Button
							type="submit"
							variant="contained"
							sx={{marginTop: 2, marginLeft: 2}}
						>
							{t("save")}
						</Button>
					</Box>
				</DialogContent>
			</Dialog>
		</Box>
	);
}
